// modules/inicio/offline/registrarProveedoresSync.js
//
// Único archivo del sistema que conoce TODAS las estrategias con soporte
// offline — es el equivalente a los imports de módulos al principio del
// useSync.js del SI-PIC. Se importa una sola vez por sus efectos
// secundarios (los registrarProveedorSync) desde App.js, antes de que se
// monte cualquier pantalla.
//
// Para agregar una estrategia nueva con offline (Habitante de Calle...),
// se agrega un bloque más acá — el resto del sistema (OfflineBanner,
// contarTodosPendientes) no necesita cambiar.

import { registrarProveedorSync } from "./syncRegistry";

import {
  contarDiscapacidadPendientes,
  sincronizarDiscapacidadPendientes,
} from "../../estrategias/rbc/offline/discapacidadOffline";

import {
  contarVejezPendientes,
  sincronizarVejezPendientes,
} from "../../estrategias/vejez/offline/vejezOffline";

import {
  contarMigrantePendientes,
  sincronizarMigrantePendientes,
} from "../../estrategias/migrante/offline/migranteOffline";

import {
  contarHabitanteCallePendientes,
  sincronizarHabitanteCallePendientes,
} from "../../estrategias/habitante_calle/offline/habitanteCalleOffline";

registrarProveedorSync({
  nombre: "discapacidad",
  etiqueta: "Discapacidad",
  contar: contarDiscapacidadPendientes,
  sincronizar: sincronizarDiscapacidadPendientes,
});

registrarProveedorSync({
  nombre: "vejez",
  etiqueta: "Vejez",
  contar: contarVejezPendientes,
  sincronizar: sincronizarVejezPendientes,
});

registrarProveedorSync({
  nombre: "migrante",
  etiqueta: "Población Migrante",
  contar: contarMigrantePendientes,
  sincronizar: sincronizarMigrantePendientes,
});

registrarProveedorSync({
  nombre: "habitante_calle",
  etiqueta: "Habitante de Calle",
  contar: contarHabitanteCallePendientes,
  sincronizar: sincronizarHabitanteCallePendientes,
});

// Ya están las 4 estrategias registradas.
